import React, { useState, useEffect } from "react";
import styled from "styled-components";
import PretendardText from "../pretendardText";

const DetailPageTitle = (props) => {
  return <DetailPageTitleWrapper {...props} />;
};

export default DetailPageTitle;

const DetailPageTitleWrapper = styled(PretendardText).attrs((props) => {})`
  font-weight: 600;
  font-size: 18px;
  line-height: 32.5px;
  letter-spacing: -0.3%0;
  color: #f3f3f3;
  margin-bottom: 20px;
`;
